import { IconButton, IconButtonProps, Tooltip } from '@material-ui/core';
import {
  AccountCircle,
  AddCircleOutline,
  ArrowRightAlt,
  BugReportOutlined,
  Description,
  List,
  MenuBook,
} from '@material-ui/icons';
import { withTooltip } from '../../core/format';
import { IcdCptApi } from '../../core/icd-cpt-api';
import { originalOrange } from '../../core/theme';
import { truCode } from '../../core/trucode';
import React from 'react';
import { documentResolver } from '../../core/document-resolver';
interface LinkButtonProperties extends IconButtonProps {
  tooltip?: string;
  route?: string;
  htmlColor?: string;
  hide?: boolean;
}

export function LogoutLink(props: LinkButtonProperties) {
  const { htmlColor, onClick } = { ...props };
  return withTooltip(
    'Sign Out',
    <IconButton id="logout-btn" onClick={onClick}>
      <AccountCircle htmlColor={htmlColor} />
    </IconButton>
  );
}

type TransitionProps = LinkButtonProperties & {
  onClick: () => void;
};

export function CodingListLink(props: TransitionProps) {
  const { onClick, tooltip, route, htmlColor, ...rest } = {
    ...{
      tooltip: 'Back to Coding List',
      route: '/list',
      htmlColor: originalOrange,
    },
    ...props,
  };

  return (
    <Tooltip title={tooltip}>
      <IconButton onClick={onClick} {...rest}>
        <List htmlColor={htmlColor} />
      </IconButton>
    </Tooltip>
  );
}

export function NextVisitLink(props: TransitionProps) {
  const { onClick, transition, tooltip, htmlColor, ...rest } = {
    ...{
      tooltip: 'Next Visit',
      htmlColor: originalOrange,
    },
    ...props,
  } as any;

  return (
    <Tooltip title={tooltip}>
      <IconButton {...rest} onClick={onClick}>
        <ArrowRightAlt htmlColor={htmlColor} />
      </IconButton>
    </Tooltip>
  );
}

export function DocumentsLink(props: LinkButtonProperties) {
  const { tooltip, route, htmlColor, hide, ...rest } = {
    ...{
      tooltip: 'Documents',
      route: '/documents',
      htmlColor: originalOrange,
    },
    ...props,
  };
  const onClick = props.onClick || (() => documentResolver.openWindow());
  return (
    <Tooltip title={tooltip}>
      <IconButton
        onClick={onClick}
        {...rest}
        style={{ visibility: hide ? 'hidden' : undefined }}
      >
        <Description htmlColor={htmlColor} />
      </IconButton>
    </Tooltip>
  );
}

export function AddButton(props: LinkButtonProperties) {
  const { tooltip, htmlColor, ...rest } = {
    ...{ tooltip: 'Add Item', htmlColor: originalOrange },
    ...props,
  };
  return (
    <Tooltip title={tooltip}>
      <IconButton {...rest}>
        <AddCircleOutline htmlColor={htmlColor} />
      </IconButton>
    </Tooltip>
  );
}

type CodeLink = LinkButtonProperties & {
  api?: IcdCptApi;
};
export function CodeReference(props: CodeLink) {
  const { tooltip, htmlColor, api, ...rest } = {
    ...{ tooltip: 'Trucode Search', htmlColor: originalOrange },
    ...props,
  } as any;

  function onOpenWindow() {
    truCode.getState().openCodeBooks({
      events: {
        onCodePosted: (e) => {
          if (api && e.codes && e.codes.length) {
            api.findCode(e.codes[0]);
          }
        },
      },
    });
  }

  return (
    <Tooltip title={tooltip}>
      <IconButton {...rest} onClick={onOpenWindow}>
        <MenuBook htmlColor={htmlColor} />
      </IconButton>
    </Tooltip>
  );
}

export function ReportBug(props: LinkButtonProperties) {
  const { tooltip, htmlColor, ...rest } = {
    ...{ tooltip: 'Report Issue', htmlColor: 'white' },
    ...props,
  };

  const onClick = () => {
    const mailto: string =
      `mailto:dhsupport@deliverhealth.com?subject=Codigo Coding Application Issue&body=Date: ${new Date()}`;
    window.location.href = mailto;
  };

  return (
    <Tooltip title={tooltip}>
      <IconButton id="report-bug-btn" {...rest} onClick={onClick}>
        <BugReportOutlined htmlColor={htmlColor} />
      </IconButton>
    </Tooltip>
  );
}
